import { useQueryClient } from '@tanstack/react-query';
import { TippyProps } from '@tippyjs/react';
import { useState } from 'react';
import {
    LuChevronDown,
    LuChevronUp,
    LuLogOut,
    LuUserCircle,
} from 'react-icons/lu';
import { MdOutlineLanguage } from 'react-icons/md';
import { redirectOwnerSearch } from '../../helpers/utils';
import { useUserProfile } from '../../hooks/useUserData';
import authenticationService from '../../services/authentication.service';
import { useToken } from '../../store/auth/tokenStore';
import ReactIcon from '../ReactIcon';
import { TooltipDropdownBase } from '../Tooltip';
import { UserOptionsContent, UserOptionsFloatingContent } from './styles';
import { makeAccessProfile } from '../../helpers/accessProfileUtil';

export default function UserOptionsDropdown({
    className,
    tipppyProps,
}: {
    className?: string;
    tipppyProps?: TippyProps;
}) {
    const user = useUserProfile().data;
    const [isDropdownOpen, setDropdownOpen] = useState(false);
    const queryClient = useQueryClient();
    const { token } = useToken();

    if (!user) return;

    const handleUserLogout = async () => {
        await authenticationService.logMeOut(queryClient);
    };

    return (
        <TooltipDropdownBase
            hideOnClick={'toggle'}
            offset={[0, 33]}
            onShow={() => setDropdownOpen(true)}
            onHide={() => setDropdownOpen(false)}
            onClickOutside={instance => instance.hide()}
            content={
                <UserOptionsFloatingContent>
                    <button
                        onClick={() => redirectOwnerSearch(token ?? undefined)}
                    >
                        <ReactIcon Icon={MdOutlineLanguage} />
                        <p>Acessar o Portal</p>
                    </button>
                    {/* <button
                        onClick={() => redirectOwnerSearch(token ?? undefined)}
                    >
                        <ReactIcon Icon={LuUserCog} />
                        <p>Proprietário</p>
                    </button> */}
                    <button onClick={handleUserLogout}>
                        <ReactIcon Icon={LuLogOut} />
                        <p>Logout</p>
                    </button>
                </UserOptionsFloatingContent>
            }
            {...tipppyProps}
        >
            <UserOptionsContent className={className}>
                <LuUserCircle size={'1.8rem'} />
                <section>
                    <p>{user.name}</p>
                    <span>{makeAccessProfile(user)}</span>
                </section>
                {!isDropdownOpen && <LuChevronDown size={'1.4rem'} />}
                {isDropdownOpen && <LuChevronUp size={'1.4rem'} />}
            </UserOptionsContent>
        </TooltipDropdownBase>
    );
}
